import React from 'react';
import StyledSelect from '../../components/StyledSelect';
import { CTA_SIZE_OPTIONS, CTA_CONVERSION_OPTIONS } from './trainAgentConstants';
import { blockStyle, labelStyle, inputStyle, styles } from './trainAgentStyles';

export function TrainAgentCtaBlock({ vm }) {
  const { ctaButtons, setCtaButton, removeCtaButton, addCtaButton } = vm;
  return (
    <div style={blockStyle}>
      <label style={labelStyle}>Botões de CTA (link + texto + cores + tamanho)</label>
      <p style={{ color: '#B0BEC5', fontSize: '13px', marginBottom: '12px' }}>
        Configure botões que o agente pode indicar no chat (ex.: comprar, agendar, ver vídeo). No treino, use &quot;indique o
        [botão #1]&quot; para o agente mostrar o botão.
      </p>
      {ctaButtons.map((btn, i) => (
        <div key={i} style={{ ...blockStyle, padding: '16px', marginBottom: '12px', background: 'rgba(0,0,0,0.2)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ color: '#00D4FF', fontWeight: '600' }}>Botão #{i + 1}</span>
            <button type="button" onClick={() => removeCtaButton(i)} style={styles.removeBtn}>
              − Remover
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '10px' }}>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Link do botão</label>
              <input
                type="url"
                value={btn.link}
                onChange={(e) => setCtaButton(i, 'link', e.target.value)}
                placeholder="https://..."
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Texto do botão</label>
              <input
                type="text"
                value={btn.label}
                onChange={(e) => setCtaButton(i, 'label', e.target.value)}
                placeholder="Ex.: Comprar agora"
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', alignItems: 'end' }}>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Cor do botão</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                <input
                  type="color"
                  value={btn.backgroundColor}
                  onChange={(e) => setCtaButton(i, 'backgroundColor', e.target.value)}
                  style={{
                    width: '40px',
                    height: '36px',
                    padding: 2,
                    border: '1px solid rgba(0,212,255,0.4)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    background: 'rgba(10,14,39,0.6)'
                  }}
                />
                <span style={{ color: '#B0BEC5', fontSize: '12px' }}>{btn.backgroundColor}</span>
              </div>
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Cor do texto</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                <input
                  type="color"
                  value={btn.textColor}
                  onChange={(e) => setCtaButton(i, 'textColor', e.target.value)}
                  style={{
                    width: '40px',
                    height: '36px',
                    padding: 2,
                    border: '1px solid rgba(0,212,255,0.4)',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    background: 'rgba(10,14,39,0.6)'
                  }}
                />
                <span style={{ color: '#B0BEC5', fontSize: '12px' }}>{btn.textColor}</span>
              </div>
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Tamanho</label>
              <StyledSelect
                value={btn.size}
                onChange={(v) => setCtaButton(i, 'size', v)}
                options={CTA_SIZE_OPTIONS}
                placeholder="Tamanho"
                style={{ marginTop: '6px' }}
              />
            </div>
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
              gap: '12px',
              alignItems: 'end',
              marginTop: '12px'
            }}
          >
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Evento de conversão</label>
              <StyledSelect
                value={btn.conversionEvent || 'none'}
                onChange={(v) => setCtaButton(i, 'conversionEvent', v)}
                options={CTA_CONVERSION_OPTIONS}
                placeholder="Evento"
                style={{ marginTop: '6px' }}
              />
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Valor</label>
              <input
                type="number"
                step="0.01"
                value={btn.value}
                onChange={(e) => setCtaButton(i, 'value', e.target.value)}
                placeholder="Ex.: 199.90"
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Moeda</label>
              <input
                type="text"
                value={btn.currency || 'BRL'}
                onChange={(e) => setCtaButton(i, 'currency', e.target.value.toUpperCase())}
                placeholder="BRL"
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Content ID</label>
              <input
                type="text"
                value={btn.contentId || ''}
                onChange={(e) => setCtaButton(i, 'contentId', e.target.value)}
                placeholder="SKU/plano"
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
            <div>
              <label style={{ ...labelStyle, fontSize: '11px' }}>Content Type</label>
              <input
                type="text"
                value={btn.contentType || 'product'}
                onChange={(e) => setCtaButton(i, 'contentType', e.target.value)}
                placeholder="product"
                style={{ ...inputStyle, marginTop: '6px' }}
              />
            </div>
          </div>
        </div>
      ))}
      <button type="button" onClick={addCtaButton} style={styles.smallButton}>
        + Adicionar botão
      </button>
    </div>
  );
}
